import { mergeAttributes } from "@tiptap/core";
import {
  BulletList,
  Heading,
  ImageBlock,
  Paragraph,
} from "features/editor/extensions";
import ExtensionKit from "features/editor/extensions/extension-kit";
import StepperList from "features/editor/extensions/Stepper/StepperList";

export const getMailRenderExtensions = (language: string) => [
  ...ExtensionKit(),
  StepperList.configure({ language }),
  Heading.configure({
    HTMLAttributes: {
      style:
        "color: #525753; font-size: 18px; font-style: normal; font-weight: 700; line-height: 30px; margin-top: 0; margin-bottom: 10px;",
    },
  }),
  Paragraph.configure({
    HTMLAttributes: {
      style:
        "color: #525753; font-size: 16px; font-style: normal; font-weight: 400; line-height: 20px; margin: 0; padding-top: 5px; padding-bottom: 5px;",
    },
  }),
  ImageBlock.extend({
    renderHTML: ({ HTMLAttributes }) => {
      const width = HTMLAttributes["data-width"] ?? "100%";
      const align = HTMLAttributes["data-align"] ?? "center";
      let style = "border-radius: 10px; margin-bottom: 28px; margin-top: 15px;";

      switch (align) {
        case "center":
          style += "margin-right: auto; margin-left: auto";
          break;
        case "left":
          style += "margin-left: 0; margin-right: auto";
          break;
        case "right":
          style += "margin-right: 0; margin-left: auto";
          break;
      }

      return ["img", mergeAttributes(HTMLAttributes, { width, style })];
    },
  }),
  BulletList.extend({
    renderHTML: ({ node, HTMLAttributes }) => {
      return [
        "ul",
        mergeAttributes(HTMLAttributes, {
          class: "bullet-list",
          style:
            "display: inline-block; list-style: unset; margin-left: 0; padding-left: 19px; margin-top: 0; margin-bottom: 0;",
        }),
        0,
      ];
    },
  }),

  // Columns.extend({
  //   renderHTML: ({ node, HTMLAttributes }) => {
  //     return ['div', { 'data-type': 'columns', class: `layout-${HTMLAttributes.layout}`, style: 'display: inline-block; margin-top: 15px; margin-bottom: 15px;'}, 0]
  //   },
  // }),
  // Column.extend({
  //   renderHTML: ({ node, HTMLAttributes }) => {
  //     //const style = HTMLAttributes['data-position'] === 'left' ? 'float: left; margin-right: 15px;' : '';
  //     const style = HTMLAttributes['data-position'] === 'left' ? 'float: left; margin-right: 30px;' : '';
  //     return ['div', mergeAttributes(HTMLAttributes, { class: HTMLAttributes['data-position'], 'data-type': 'column', style }), 0]
  //   },
  // })
  // Column.extend({
  //   renderHTML: ({ node, HTMLAttributes }) => {
  //     return ['div', mergeAttributes(HTMLAttributes, { class: HTMLAttributes['data-position'], 'data-type': 'column' }), 0]
  //   },
  // })
];
